<template>
  <div
    class="text-input"
    :class="{ 'button-show': inputShowButton, disabled: inputDisabled }"
  >
    <input
      type="text"
      :placeholder="placeHolderText"
      @input="$emit('input', $event.target.value)"
      :maxlength="maxLength ? maxLength : ''"
      :disabled="inputDisabled"
      :value="value"
    />
    <button
      type="button"
      v-if="inputShowButton"
      :disabled="inputDisabled"
      @click="bubbleClickWithParam"
    >
      {{ buttonTextDisplay }}
    </button>
  </div>
</template>

<script>
export default {
  name: "CertInputText",
  props: {
    value: String,
    placeHolderText: String,
    maxLength: Number,
    inputDisabled: {
      type: Boolean,
      default: false,
    },
    inputShowButton: {
      type: Boolean,
      default: false,
    },
    inputButtonText: {
      type: String,
      default: "",
    },
    inputButtonClickParam: {},
  },
  computed: {
    buttonTextDisplay() {
      if (this.inputButtonText.length > 2) {
        return this.inputButtonText.substring(0, 2);
      }

      return this.inputButtonText;
    },
  },
  methods: {
    bubbleClickWithParam(e) {
      if (this.inputButtonClickParam !== undefined) {
        this.$emit("buttonclick", {
          length: this.maxLength,
          param: this.inputButtonClickParam,
          e,
        });
      } else {
        this.$emit("buttonclick", { e });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mtm {
  .text-input {
    input[type="text"]:not(:disabled):hover,
    input[type="text"]:not(:disabled):focus {
      border-color: $exMtm;
    }
    input[type="text"]:not(:disabled):hover ~ button,
    input[type="text"]:not(:disabled):focus ~ button {
      border-color: $exMtm;
    }
    button:not(:disabled):hover,
    button:not(:disabled):focus {
      border-color: $exMtm;
    }
  }
  .text-input:not(.disabled):hover button,
  .text-input:not(.disabled):hover input[type="text"] {
    border-color: $exMtm;
  }
}
.text-input {
  position: relative;
  input[type="text"] {
    height: 50px;
    width: 100%;
    border: 1px solid $borderLightGray;
    border-radius: $borderRadius;
    background-color: $bgLightGray;
    padding: 15px;
  }

  button {
    position: absolute;
    right: 0;
    width: 50px;
    height: 50px;
    border: 1px solid $borderLightGray;
    background-color: #fff;
    padding: 15px;
    text-align: center;
    text-transform: capitalize;
    cursor: pointer;
  }

  button:disabled {
    cursor: default;
  }

  input[type="text"]:not(:disabled):hover,
  input[type="text"]:not(:disabled):focus {
    border-color: $exBlue;
  }

  input[type="text"]:not(:disabled):hover ~ button,
  input[type="text"]:not(:disabled):focus ~ button {
    border-color: $exBlue;
  }

  button:not(:disabled):hover,
  button:not(:disabled):focus {
    border-color: $exBlue;
  }
}

.text-input:not(.disabled):hover button,
.text-input:not(.disabled):hover input[type="text"] {
  border-color: $exBlue;
}

.text-input.button-show {
  input[type="text"] {
    padding-right: 55px;
  }
}
</style>
